var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionEditIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    transform: "matrix(-1 0 0 1 38 0)",
    fill: "#252D34",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H16C11 9 9 11 9 16V22C9 27 11 29 16 29H22C27 29 29 27 29 22V20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0399 10.02L15.1599 17.9C14.8599 18.2 14.5599 18.79 14.4999 19.22L14.0699 22.23C13.9099 23.32 14.6799 24.08 15.7699 23.93L18.7799 23.5C19.1999 23.44 19.7899 23.14 20.0999 22.84L27.9799 14.96C29.3399 13.6 29.9799 12.02 27.9799 10.02C25.9799 8.02001 24.3999 8.66001 23.0399 10.02Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9099 11.15C22.5799 13.54 24.4499 15.41 26.8499 16.09",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEditIconDark);
export default __webpack_public_path__ + "static/media/action-edit-icon-dark.043fc51e4243bd3c647e5503902a1502.svg";
export { ForwardRef as ReactComponent };